export default __webpack_public_path__ + "static/media/nav-qa-outline.ecb63b71.svg";